import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Process, ProcessStatus } from 'src/app/core/models/process.model';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule, MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { DatePipe, CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-process-edit-dialog',
  standalone: true,
  templateUrl: './process-edit-dialog.component.html',
  imports: [
    CommonModule,
    DatePipe,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatOptionModule,
    MatIconModule,
    MatExpansionModule,
    MatSelectModule,
    MatNativeDateModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class ProcessEditDialogComponent {
  editForm: FormGroup;
  processStatusList: string[] = Object.values(ProcessStatus); // Lista de status do processo

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ProcessEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Process
  ) {
    // Inicialização do formulário reativo com os campos adequados
    this.editForm = this.fb.group({
      processNumber: [{ value: data.numeroProcesso, disabled: true }],
      processType: [{ value: data.idTipoProcesso, disabled: true }],
      dueDays: [{ value: data.dueDays, disabled: true }],
      empresa: [data.empresa, Validators.required],
      propertyRegister: [data.imovel?.codigo, Validators.required],
      descricao: [data.descricao, Validators.required],
      theme: [data.idModalidade, Validators.required],
      group: [data.idModalidadeGrupo, Validators.required],
      registerDate: [{ value: data.registerDate, disabled: true }, Validators.required],
      status: [{ value: data.situacao, disabled: true }, Validators.required],
    });
  }

  // Função para salvar os dados editados
  onSave() {
    if (this.editForm.valid) {
      const updatedProcess = this.editForm.getRawValue();
      this.dialogRef.close(updatedProcess);
    } else {
      this.editForm.markAllAsTouched();
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}